export default __webpack_public_path__ + "static/guerrilla_l1-27ebc2a33cc13d0ef98189ee43e7cb21.jpg";